import { AvailableFeatures } from "./features";

export enum FeatureAccessLevel {
  TIER_2 = "tier-2",
  TIER_1 = "tier-1",
  TRIAL = "trial",
  FREE = "free",
}
export enum SubscriptionType {
  FEATURE_ACCESS = "feature_access",
  MFRAT = "mfrat",
}
export const TIER_HIERARCHY = [
  FeatureAccessLevel.TIER_2,
  FeatureAccessLevel.TIER_1,
  FeatureAccessLevel.FREE,
];

export const FeatureAccessSubscriptionNaming: Record<
  FeatureAccessLevel,
  string
> = {
  [FeatureAccessLevel.TRIAL]: "Premium Trial",
  [FeatureAccessLevel.TIER_1]: "Essential",
  [FeatureAccessLevel.TIER_2]: "Premium",
  [FeatureAccessLevel.FREE]: "Basic",
};

export const TIERS_TO_FEATURES: Record<
  FeatureAccessLevel,
  readonly AvailableFeatures[]
> = {
  [FeatureAccessLevel.TRIAL]: [
    AvailableFeatures.RISK,
    AvailableFeatures.COUNTERS,
    AvailableFeatures.ORGANIZATION_MANAGEMENT,
    AvailableFeatures.MAINTENANCE_INTELLIGENCE,
    AvailableFeatures.ENGINE_TRENDING,
    AvailableFeatures.SQUAWKS,
    AvailableFeatures.REPORTS,
    // AvailableFeatures.BINDER,
    // AvailableFeatures.TRAINING,
    AvailableFeatures.WEIGHT_AND_BALANCE,
    AvailableFeatures.PERFORMANCE,
  ],
  [FeatureAccessLevel.TIER_1]: [
    AvailableFeatures.RISK,
    AvailableFeatures.COUNTERS,
    AvailableFeatures.ORGANIZATION_MANAGEMENT,
    AvailableFeatures.MAINTENANCE_INTELLIGENCE,
    AvailableFeatures.ENGINE_TRENDING,
    AvailableFeatures.SQUAWKS,
    AvailableFeatures.REPORTS,
    AvailableFeatures.WEIGHT_AND_BALANCE,
    AvailableFeatures.PERFORMANCE,
  ],
  [FeatureAccessLevel.TIER_2]: [
    AvailableFeatures.RISK,
    AvailableFeatures.COUNTERS,
    AvailableFeatures.ORGANIZATION_MANAGEMENT,
    AvailableFeatures.MAINTENANCE_INTELLIGENCE,
    AvailableFeatures.ENGINE_TRENDING,
    AvailableFeatures.SQUAWKS,
    AvailableFeatures.REPORTS,
    // AvailableFeatures.BINDER,
    // AvailableFeatures.TRAINING,
    AvailableFeatures.WEIGHT_AND_BALANCE,
    AvailableFeatures.PERFORMANCE,
    AvailableFeatures.PREMIUM_MFRAT,
  ],
  [FeatureAccessLevel.FREE]: [
    AvailableFeatures.ORGANIZATION_MANAGEMENT,
    AvailableFeatures.RISK,
    AvailableFeatures.COUNTERS,
  ],
};

export function uniqueFeatures(tier: FeatureAccessLevel) {
  const features = TIERS_TO_FEATURES[tier];
  const previousTiers = TIER_HIERARCHY.slice(
    TIER_HIERARCHY.indexOf(tier) + 1,
    TIER_HIERARCHY.length,
  );
  const previousFeatures = previousTiers.flatMap(
    (previousTier) => TIERS_TO_FEATURES[previousTier],
  );
  return features.filter((feature) => !previousFeatures.includes(feature));
}

const DEFAULT_TRIAL_DURATION_DAYS = 30;
// Trial duration constants
export const TRIAL_DURATION_DAYS =
  import.meta.env.VITE_TRIAL_DURATION_DAYS ?? DEFAULT_TRIAL_DURATION_DAYS;
export const TRIAL_DURATION_DISPLAY =
  import.meta.env.VITE_TRIAL_DURATION_DISPLAY ?? "1 Month";
